import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleUpSmall"><Path d="M7.17432 13.7499L12 7.81055L16.8258 13.7499H7.17432Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
